import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactLoading from "react-loading";
import Breadcrumb from "../../../components/breadcrumb";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import RecordsModeToggle from "../components/RecordsModeToggle";
import RecordsSection from "../components/RecordsSection";
import useRecordsData from "../hooks/useRecordsData";

const RECORDS_MODE_STORAGE_KEY = "records-mode";

function Records() {
    const location = useLocation();
    const [mode, setMode] = useState(() => {
        try {
            return sessionStorage.getItem(`${RECORDS_MODE_STORAGE_KEY}:${location.key}`) || "totales-carrera";
        } catch {
            return "totales-carrera";
        }
    });
    const { isLoading, isError, modeOptions, modeSections } = useRecordsData();

    useEffect(() => {
        document.title = "Récords";
    }, []);

    useEffect(() => {
        try {
            sessionStorage.setItem(`${RECORDS_MODE_STORAGE_KEY}:${location.key}`, mode);
        } catch {
            // ignore storage errors
        }
    }, [mode, location.key]);

    const sections = useMemo(() => {
        return modeSections?.[mode] || [];
    }, [mode, modeSections]);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pt-2 md:pb-10">
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/" },
                        { label: "Récords", isCurrent: true },
                    ]}
                    className="mb-4"
                />

                <div className="mb-12">
                    <div className="mb-6 sm:mb-8">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-2 sm:mb-3 border-l-4 border-red-500 pl-4">
                            Récords
                        </h1>
                        <p className="text-slate-400 font-medium text-base sm:text-lg max-w-3xl pl-4">
                            Top 5 histórico por categoría estadística del Club Atlético Aguada.
                        </p>
                    </div>

                    <div className="mt-6 flex justify-center">
                        <RecordsModeToggle mode={mode} onChange={setMode} options={modeOptions} />
                    </div>
                </div>

                {isLoading && (
                    <div className="rounded-xl border border-white/10 bg-[#102216] p-10">
                        <ReactLoading type="bars" color="#22c55e" width={80} className="text-center m-auto mb-10" />
                        <p className="text-center text-slate-200 text-lg font-semibold">Cargando récords...</p>
                    </div>
                )}

                {isError && !isLoading && (
                    <div className="rounded-xl border border-red-400/30 bg-red-950/20 p-8 text-center text-red-200 font-medium">
                        No se pudieron cargar los récords en este momento.
                    </div>
                )}

                {!isLoading && !isError && sections.map((section) => (
                    <RecordsSection
                        key={section.id}
                        title={section.title}
                        subtitle={section.subtitle}
                        cards={section.cards}
                    />
                ))}
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Records;
